import { colors } from '@ardoq/design-tokens';
import { header2 } from '@ardoq/typography';
import styled from 'styled-components';
import { FlexBox } from '@ardoq/layout';
import { IconButton } from '@ardoq/button';
import { IconName } from '@ardoq/icons';

type ViewpointModalHeaderProps = {
  title: string;
  subtitle?: React.ReactNode;
  closeButtonProps?: { onClick: VoidFunction; label: string };
};

// TODO CL consider moving to Island in DS,
// Current design is a bit too specific to use existing props
export const ViewpointModalHeader = ({
  title,
  subtitle,
  closeButtonProps,
}: ViewpointModalHeaderProps) => (
  <div>
    <FlexBox
      gap="small"
      align="center"
      justify="space-between"
      marginBottom="medium"
    >
      <Header>{title}</Header>
      {closeButtonProps && (
        <IconButton
          iconName={IconName.CLOSE}
          onClick={closeButtonProps.onClick}
          label={closeButtonProps.label}
        />
      )}
    </FlexBox>

    <SubTitle>{subtitle}</SubTitle>
  </div>
);

const Header = styled.h2`
  ${header2};
  margin: 0;
`;

const SubTitle = styled.div`
  color: ${colors.grey400};
`;
